export default __webpack_public_path__ + "static/media/Anurag_Yadav_Android_Developer__Masai.2c901c40.pdf";